import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { statements } from '../statements-config/HR';
import { settingsDetails } from '../settings-details-config/HR';
import { overdraftDetail } from '../overdraft-detailed-v2-config/HR';

export const currentAccount: DeepPartial<CurrentAccountConfig> = {
    overdraftDetail,
    roundingSavings: {
        enabled: false,
    },
    sepaMandatesRead: {
        enabled: false,
    },
    accountAddress: {
        enabled: false,
    },
    statements,
    settingsDetails,
    layout: {
        productInfo: {
            showBalanceAndDisposableAmounts: true,
        },
    },
};
